// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCLFVOYJJcWqpAQw5Ae36ISpT8CUzqq0QI",
    authDomain: "project3-d98a6.firebaseapp.com",
    projectId: "project3-d98a6",
    storageBucket: "project3-d98a6.appspot.com",
    messagingSenderId: "381894570337",
    appId: "1:381894570337:web:5c6a50508e515b0e585520"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export default firebase;